export default {
  isBadRequest(code) {
    return code === 400
  },
  isNotFound(code) {
    return code === 404
  }
}
